import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "ml-4" }, "Palun valige töötaja kellele ülesvõtted lisada", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "align-top px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Nimi "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "align-top px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Isikukood "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "align-top px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Kliinik ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_SelectWorkerItem = _resolveComponent("SelectWorkerItem")!
  const _component_BaseTableBodyWrapper = _resolveComponent("BaseTableBodyWrapper")!
  const _component_BaseTableWrapper = _resolveComponent("BaseTableWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_InputField, {
      label: "Otsi töötajat",
      value: _ctx.nameSearchInput,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nameSearchInput) = $event)),
      "is-autocomplete": false,
      class: "w-64 mt-4 ml-5"
    }, null, 8, ["value"]),
    _createVNode(_component_BaseTableWrapper, null, {
      default: _withCtx(() => [
        _hoisted_3,
        _createVNode(_component_BaseTableBodyWrapper, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredWorkers, (worker) => {
              return (_openBlock(), _createBlock(_component_SelectWorkerItem, {
                key: worker.uid,
                worker: worker,
                onClick: ($event: any) => (_ctx.onWorker(worker.uid))
              }, null, 8, ["worker", "onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}